<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="app" :class="vueAppClasses">
    <loading :active.sync="this.$store.getters.getIsLoading" :is-full-page="true"></loading>
    <router-view @setAppClasses="setAppClasses"/>
    <!--    Error pop up-->
    <vx-modal classContent="popup-example" title="Email schreiben" :active.sync="isError" v-if="isError" detach>
      <p>{{errorMessage}}</p>
    </vx-modal>
    <!--    Error pop up-->
  </div>
</template>
<script>
  import themeConfig from '@/../themeConfig.js'
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';

  export default {
    components: {Loading},
    data() {
      return {
        vueAppClasses: [],
        isError: this.$store.getters.getError.isError,
        errorMessage: this.$store.getters.getError.errorMessage
      }
    },
    watch: {
      '$store.state.theme'(val) {
        this.toggleClassInBody(val)
      },
      '$vs.rtl'(val) {
        document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
      }
    },
    methods: {
      toggleClassInBody(className) {
        if (className == 'dark') {
          if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
          document.body.classList.add('theme-dark')
        } else if (className == 'semi-dark') {
          if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
          document.body.classList.add('theme-semi-dark')
        } else {
          if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
          if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        }
      },
      setAppClasses(classesStr) {
        this.vueAppClasses.push(classesStr)
      },
      handleWindowResize() {
        this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

        // Set --vh property
        document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
      },
      handleScroll() {
        this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
      }
    },
    mounted() {
      this.toggleClassInBody(themeConfig.theme)
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      let vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`);

    },
    async created() {
      let dir = this.$vs.rtl ? "rtl" : "ltr"
      document.documentElement.setAttribute("dir", dir)

      window.addEventListener('resize', this.handleWindowResize)
      window.addEventListener('scroll', this.handleScroll)

    },
    destroyed() {
      window.removeEventListener('resize', this.handleWindowResize)
      window.removeEventListener('scroll', this.handleScroll)
    },
  }

</script>
